// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const tapu_koko: PokeData = {
  "id": 785,
  "name": "tapu-koko",
  "height": 18,
  "weight": 205,
  "base_experience": 257,
  "types": [
    PokeType.ELECTRIC,
    PokeType.FAIRY
  ],
  "api_moves": [
    "thunder-shock",
    "agility",
    "quick-attack",
    "screech",
    "withdraw",
    "mirror-move",
    "false-swipe",
    "spark",
    "mean-look",
    "charge",
    "shock-wave",
    "power-swap",
    "brave-bird",
    "discharge",
    "electro-ball",
    "wild-charge",
    "fairy-wind",
    "electric-terrain",
    "natures-madness"
  ],
  "moves": [
    "thunder-shock",
    "quick-attack",
    "brave-bird",
    "wild-charge",
    "electric-terrain",
    "starfall",
    "quick-tempo",
    "thunder",
    "play-rough",
    "volt-crash",
    "dazzling-gleam",
    "mist-terrain",
    "moonblast"
  ],
  "evolution_chain": {
    "id": 409,
    "item": null,
    "species": [
      {
        "name": "tapu-koko",
        "order": 785,
        "types": [
          PokeType.ELECTRIC,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 94,
    "speed": 163,
    "ability_power": 144
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
